import React from 'react';
import { invert } from '../utils';
import { Price } from '../Price';
import { withNotifications } from '../../../common/notifications/NotificationsContext';
import { onOpenDisclosure } from '../../../common/notifications/NotificationsProvider';

const Incentive = ({ incentive, notifications }) => {
  const { show } = notifications;

  let incentiveDisclaimers = '';

  incentive.disclaimers.map(
    (disclaimer) => (incentiveDisclaimers += disclaimer + '<br>')
  );

  return (
    <div className="incentive">
      <div className="incentive__program">
        <div className="incentive__event-name">{incentive.program}</div>
        {incentiveDisclaimers ? (
          <button
            className="incentive__disclosure"
            onClick={(event) =>
              onOpenDisclosure(event, show, incentiveDisclaimers)
            }>
            <Price className="incentive" value={invert(incentive.value)} />
            <span className="incentive__disclaimer-dagger">†</span>
          </button>
        ) : (
          <Price
            className="incentive"
            value={invert(incentive.value)}
            onClick={(event) =>
              onOpenDisclosure(event, show, incentiveDisclaimers)
            }
          />
        )}
      </div>
    </div>
  );
};

const AboveTheLineIncentives = ({ pricing, notifications, isFamilyFirst }) => {
  const {
    incentives: { lines },
  } = pricing;
  const incentives = lines.filter((line) => line.belowTheLine === false);
  const incentiveLines = incentives.map((incentive, index) => (
    <Incentive
      key={`programType-${index}`}
      incentive={incentive}
      notifications={notifications}
    />
  ));
  return <div className="incentives">{incentiveLines}</div>;
};

export default withNotifications(AboveTheLineIncentives);
